module.exports = __webpack_public_path__ + "static/media/youtube.98744ed6.png";